/**
 * Newsletter subscription — Sendy double opt-in + Shopify customer tag.
 *
 * 1. preventDefault on form submit
 * 2. Validate email + GDPR consent
 * 3. POST → newsletter.ilico.io/subscribe (Sendy native double opt-in)
 *    → user receives confirm email
 * 4. Fire-and-forget POST → Shopify /contact (create customer with newsletter tag)
 * 5. Inline success/error message
 */
(function () {
  'use strict';

  function nl(key, fallback) {
    return (window.JackeryConfig && window.JackeryConfig.newsletter && window.JackeryConfig.newsletter[key]) || fallback;
  }

  function showMessage(form, type, text) {
    var msg = form.querySelector('[data-newsletter-message]');
    if (!msg) {
      msg = document.createElement('div');
      msg.setAttribute('data-newsletter-message', '');
      msg.style.cssText = 'margin-top:0.75rem;padding:0.625rem 0.875rem;border-radius:8px;font-size:0.875rem;';
      form.appendChild(msg);
    }
    var styles = {
      success: 'background:rgba(39,174,96,0.15);color:#27ae60;border:1px solid rgba(39,174,96,0.3);',
      error: 'background:rgba(231,76,60,0.15);color:#e74c3c;border:1px solid rgba(231,76,60,0.3);',
      info: 'background:rgba(253,80,0,0.10);color:#FD5000;border:1px solid rgba(253,80,0,0.3);'
    };
    msg.style.cssText += styles[type] || styles.info;
    msg.setAttribute('data-message-type', type);
    msg.textContent = text;
    msg.setAttribute('role', type === 'error' ? 'alert' : 'status');
  }

  function setLoading(form, loading) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = nl('sending_btn', 'Odesílám…');
      btn.disabled = true;
    } else {
      if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
      btn.disabled = false;
    }
  }

  async function subscribeToSendy(email, listId, extra) {
    // Delegate to the shared helper (theme/assets/sendy.js). Opaque no-cors
    // response → always optimistic success; double opt-in confirms via email.
    if (!window.JackerySendy || !window.JackerySendy.subscribe) {
      return { ok: false, error: nl('config_missing', 'Konfigurace chybí.') };
    }
    var res = await window.JackerySendy.subscribe({ email: email, list: listId, extra: extra || {} });
    if (res.ok) return { ok: true, status: 'new' };
    return { ok: false, error: nl('network_error', 'Síťová chyba') };
  }

  function tagShopifyCustomer(email) {
    // Fire-and-forget — creates Shopify customer with newsletter tag
    // for future Shopify Email marketing. Independent of Sendy success/failure.
    var data = new FormData();
    data.append('form_type', 'customer');
    data.append('utf8', '✓');
    data.append('contact[email]', email);
    data.append('contact[accepts_marketing]', 'true');
    data.append('contact[tags]', 'newsletter');
    fetch('/contact', { method: 'POST', body: data, redirect: 'manual' })
      .catch(function () { /* ignore — secondary path */ });
  }

  async function handleSubmit(event, form) {
    event.preventDefault();

    var listId = form.dataset.sendyList || form.closest('[data-sendy-list]')?.dataset.sendyList;
    if (!listId) {
      console.error('Newsletter form missing data-sendy-list attribute');
      showMessage(form, 'error', nl('config_missing', 'Konfigurace newsletteru chybí. Kontaktujte podporu.'));
      return;
    }

    var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
    var consentInput = form.querySelector('input[name="contact[accepts_marketing]"]');
    if (!emailInput) return;

    var email = emailInput.value.trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      showMessage(form, 'error', nl('invalid_email', 'Zadej prosím platnou e-mailovou adresu.'));
      emailInput.focus();
      return;
    }

    if (consentInput && !consentInput.checked) {
      showMessage(form, 'error', nl('consent_required', 'Pro přihlášení musíš souhlasit se zpracováním e-mailu.'));
      consentInput.focus();
      return;
    }

    setLoading(form, true);
    showMessage(form, 'info', nl('sending', 'Odesílám přihlášku…'));

    // Per-form welcome-email copy → Sendy [email_nadpis,fallback=…] in the shared
    // welcome autoresponder, so a newsletter signup gets a newsletter-flavoured
    // hero (not the competition one). Sendy has no if-then, only fallback.
    var extra = {};
    if (form.dataset.emailNadpis) extra.email_nadpis = form.dataset.emailNadpis;
    if (form.dataset.emailLead) extra.email_lead = form.dataset.emailLead;

    try {
      var result = await subscribeToSendy(email, listId, extra);
      if (result.ok) {
        if (result.status === 'new') {
          showMessage(form, 'success', nl('success_new', '✓ Odkaz pro potvrzení jsme ti poslali e-mailem. Klikni na něj pro dokončení.'));
        } else {
          showMessage(form, 'success', nl('already', '✓ Tento e-mail už je přihlášený.'));
        }
        emailInput.value = '';
        if (consentInput) consentInput.checked = false;
        // Background: tag in Shopify too
        tagShopifyCustomer(email);
      } else {
        showMessage(form, 'error', result.error || nl('error_generic', 'Něco se pokazilo. Zkus to prosím znovu.'));
      }
    } catch (err) {
      console.error('Newsletter subscribe error:', err);
      showMessage(form, 'error', nl('network_retry', 'Síťová chyba. Zkontroluj připojení a zkus znovu.'));
    } finally {
      setLoading(form, false);
    }
  }

  function init() {
    document.querySelectorAll('form[data-newsletter-form]').forEach(function (form) {
      if (form.dataset.newsletterInitialized) return;
      form.dataset.newsletterInitialized = 'true';
      form.addEventListener('submit', function (e) { handleSubmit(e, form); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
